import React from 'react'

export const Nosotros = () => {
  return (
    <div className='contenedor-clasico'>
      <h1>Nosotros</h1>

      <p>En Papelería Belén somos más que una tienda de artículos escolares y de oficina; somos un aliado en el desarrollo educativo, profesional y personal de nuestra comunidad. Desde nuestros inicios, nos hemos comprometido a brindar productos de calidad, atención cercana y soluciones prácticas para cada necesidad.</p>
    </div>
  )
}
